/* unplugin-vue-components disabled */import { render } from "./CoveoAINotification.vue?vue&type=template&id=38c09bbb"
import script from "./CoveoAINotification.vue?vue&type=script&lang=js"
export * from "./CoveoAINotification.vue?vue&type=script&lang=js"

import "./CoveoAINotification.vue?vue&type=style&index=0&id=38c09bbb&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__